export default __webpack_public_path__ + "static/media/91.43a2e8e8.png";